(function () {
  'use strict';

  // WCAG 3.3.1 -- aria-invalid + aria-describedby binding for ask-a-question form.
  // Uses textContent only; no innerHTML anywhere.

  const FIELDS = [
    {
      id: 'AskQuestionForm-Name',
      errorId: 'AskQuestionForm-Name-error',
      validate(value) {
        if (!value.trim()) return 'Name is required.';
        return null;
      },
    },
    {
      id: 'AskQuestionForm-Email',
      errorId: 'AskQuestionForm-Email-error',
      validate(value) {
        if (!value.trim()) return 'Email address is required.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) return 'Enter a valid email address.';
        return null;
      },
    },
    {
      id: 'AskQuestionForm-Message',
      errorId: 'AskQuestionForm-Message-error',
      validate(value) {
        if (!value.trim()) return 'Message is required.';
        return null;
      },
    },
  ];

  function showError(input, errorEl, message) {
    input.setAttribute('aria-invalid', 'true');
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
  }

  function clearError(input, errorEl) {
    input.removeAttribute('aria-invalid');
    errorEl.textContent = '';
    errorEl.classList.add('hidden');
  }

  function bindField(input, errorEl, validate) {
    // Clear the error as the user corrects the field.
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true' && !validate(input.value)) {
        clearError(input, errorEl);
      }
    });
    input.addEventListener('blur', function () {
      if (input.getAttribute('aria-invalid') === 'true' && !validate(input.value)) {
        clearError(input, errorEl);
      }
    });
  }

  function setupForm(form) {
    const instances = FIELDS.map(({ id, errorId, validate }) => ({
      input: form.querySelector('#' + id),
      errorEl: form.querySelector('#' + errorId),
      validate,
    })).filter(({ input, errorEl }) => input && errorEl);

    instances.forEach(({ input, errorEl, validate }) => {
      bindField(input, errorEl, validate);
    });

    form.addEventListener('submit', function (event) {
      let firstInvalid = null;
      let hasErrors = false;

      instances.forEach(({ input, errorEl, validate }) => {
        const message = validate(input.value);
        if (message) {
          showError(input, errorEl, message);
          if (!firstInvalid) firstInvalid = input;
          hasErrors = true;
        } else {
          clearError(input, errorEl);
        }
      });

      if (hasErrors) {
        event.preventDefault();
        if (firstInvalid) firstInvalid.focus();
      }
    });
  }

  function init() {
    const form = document.getElementById('ask-question-form');
    if (form) {
      setupForm(form);
      return;
    }

    // The form lives inside a <basic-modal> that is always in the DOM but may not
    // have been inserted yet at script evaluation time.  Watch for it.
    const observer = new MutationObserver(function () {
      const f = document.getElementById('ask-question-form');
      if (f) {
        observer.disconnect();
        setupForm(f);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
